// src/styles/typography.js
// Typography utility classes based on your design system

// Heading styles using Figtree font
export const typography = {
  // GH - Main display text
  gh: 'font-figtree text-gh',
  
  // Headings H1-H5 using Figtree
  h1: 'font-figtree text-h1',
  h2: 'font-figtree text-h2',
  h3: 'font-figtree text-h3',
  h4: 'font-figtree text-h4',
  h5: 'font-figtree text-h5',
  
  // Paragraph using Open Sans
  p: 'font-openSans text-p',
  
  // Subheadings using Open Sans
  sh1: 'font-openSans text-sh1',
  sh2: 'font-openSans text-sh2',
  sh3: 'font-openSans text-sh3',
};

// Individual exports for specific use cases
export const { gh, h1, h2, h3, h4, h5, p, sh1, sh2, sh3 } = typography;

// Utility function to combine typography with additional classes
export const textStyle = (baseStyle, additionalClasses = '') => {
  return `${baseStyle} ${additionalClasses}`.trim();
};

// Example usage:
// import { h1, p, textStyle } from './styles/typography';
// 
// <h1 className={h1}>Main Heading</h1>
// <p className={p}>Regular paragraph text</p>
// <h2 className={textStyle(h2, 'text-blue-600')}>Custom colored heading</h2>
